/**
 * BigwaDegradedBanner — Thin info bar when resilience init failed with an error.
 *
 * Only shown when state === 'degraded' AND reason === 'error'.
 * NOT shown when scope is simply absent (normal for Phase 1).
 * Dismissable per session via sessionStorage.
 */

import React, { useState } from 'react';
import { driveConfig } from '../services/driveConfig';
import { useDriveInit } from '../hooks/useDriveInit';

const DISMISS_KEY = 'bigwa_degraded_dismissed';

export const BigwaDegradedBanner: React.FC = () => {
  const { state } = useDriveInit();
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem(DISMISS_KEY) === 'true'
  );

  const reason = driveConfig.getDegradedReason();
  const shouldShow = state === 'degraded' && reason === 'error' && !dismissed;

  if (!shouldShow) return null;

  const handleDismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, 'true');
    setDismissed(true);
  };

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      padding: '6px 16px',
      background: '#f5f0e8',
      fontSize: '13px',
      color: '#8a7e6b',
      lineHeight: 1.4,
      position: 'relative',
    }}>
      <svg width="14" height="14" viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0 }}>
        <circle cx="8" cy="8" r="7" stroke="#8a7e6b" strokeWidth="1.2" />
        <line x1="8" y1="5" x2="8" y2="9" stroke="#8a7e6b" strokeWidth="1.2" strokeLinecap="round" />
        <circle cx="8" cy="11.5" r="0.8" fill="#8a7e6b" />
      </svg>
      <span>Protecao avancada indisponivel. O app funciona normalmente.</span>
      <button
        onClick={handleDismiss}
        aria-label="Fechar"
        style={{
          position: 'absolute',
          right: '12px',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: '2px',
          color: '#8a7e6b',
          fontSize: '16px',
          lineHeight: 1,
        }}
      >
        ×
      </button>
    </div>
  );
};
